
<div class="landing_main_wraper fade-in-down" style="text-align:center">
	<!-- Logout Button -->
	<button title="Logout" class="btn-logout logout-user" type="button" id="btn-logout" (click)="logout()">
		<img src="{{assetsPath.brandingAssetsStudent.logout}}">
		<span class="sr-only">Logout</span>
	 </button>
    <div class="main-container">
        <div class="logo_section">
            <img src="{{assetsPath.brandingAssetsStudent.logo}}" alt="Logo">
        </div>
        <div class="justify_space_between" *ngIf="title">
            <div class="landing_content_area">
				<div class="parentbox">
                <div [ngClass]="[boxArea]">
                    <h6>Student Bot</h6>
                    <h5>Goals</h5>
                    <p> The goal of this pilot is to implement and validate responses generated by chatbot for students trained using selected data sources with Generative AI technology and learn the following.</p>
                    <ul>
                        <li>Provide accurate, complete, and simple answers to the full range of common student questions with minimal training  </li>
                        <li>Provide students the information they need without having to speak to an agent, thus reducing top volume call drivers  </li>
                    </ul>
                    <h5>Nature of Information</h5>
				
					<div>
						<div class="text-content">
                            The responses generated by this chatbot using generative AI are based on vast amounts of data and algorithms, but they may not always be correct, complete, or up-to-date. Users should treat the information as a starting point and verify from trusted sources before making decisions based on it.  For more information concerning the use of this chatbot please click the link to Covista’s Chatbot Use Acknowledgement Document.
							</div>
					</div>
					<div [class.isDisabled]="disabledButton" [ngClass]="[buttonArea]"  (click)="readAcknowledgment()"><div class="child1" >Please read and acknowledge document</div><div *ngIf="toshowTick" class="child2"><div  id="checkmark"></div></div></div>
					<div>
					<div *ngIf ="showAcknowledge" class="acknowledge_container">
						<div class="acknowledge_heading">
							Acknowledge document
                            <span (click)="closeButton()" class="close"></span>
						</div>
						<div class="acknowledge_content_window">
							<div class="acknowledge_content">
								<div class="acknowledge_content_style">
								<br>
								<br>
								<br>
								<p>Acknowledge document</p> 
								<ol>
									<li>Nature of Information: The responses generated by this chatbot using generative AI 
										are based on vast amounts of data and algorithms, but they may not always be 
										correct, complete, or up-to-date. Users should treat the information as a starting 
										point and verify from trusted sources before making decisions based on it.</li>
									<li>No Human Oversight: The responses are generated automatically, without human 
										oversight or intervention. As such, they may occasionally contain errors, 
										misinterpretations, or irrelevant information. </li>
									<li> No Personal Advice: The information provided by the chatbot is general in nature 
										and should not be considered as personal advice. Users should consult with relevant 
										professionals before making decisions, especially in areas that require specialized 
										knowledge or expertise. </li>
									<li>Data Privacy: While this chatbot is designed to prioritize user privacy, users are 
										advised not to share sensitive, personal, or confidential information. We do not
										guarantee complete confidentiality or security.</li>
									<li>Limitation of Liability: The developers, operators, and affiliates of this chatbot will 
										not be liable for any direct, indirect, incidental, consequential, or special damages, 
										including but not limited to damages for loss of profits, goodwill, or data, arising out 
										of or in connection with the use of this chatbot. </li>
									<li>Not a Substitute: This chatbot is not a substitute for human expertise or judgment. 
										Relying solely on its responses without external validation can lead to misinformed 
										decisions.</li>
								</ol>
								</div>
							</div>
						</div>
						<div class="checkbox">
							<input type="checkbox" id ="chkbox" (click)="clickAcknowledgment()" [(ngModel)]="toShow" (change)="acknowledgeTerms($event.target.checked)">&nbsp;I acknowledge and agree to the terms and conditions acknowledgment document.
							&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							<button [disabled]="isDisabled" class="conversation_btn"  (click)="startConversation()" >Start a conversation</button>
						</div>
						</div>
					</div>
					</div>
					</div>
				</div>
            </div>
        </div>
    </div>  


<div *ngIf="chatIconShow" class="hk-wrapper" data-layout="twocolumn" data-menu="light" data-footer="simple" data-hover="active"
		data-submenu="active">

		<!-- Chat Popup -->
		<div class="hk-chatbot-popup d-md-block d-flex" style="height: 80%;" [ngClass]="{'fade-in': showDiv, 'fade-out': !showDiv, 'visible': isVisible, 'invisible': !isVisible}" draggable="true">
			<header style="padding-bottom: 0.5rem;">
				<div class="chatbot-head-top">
					
					<!-- <span class="text-white">{{chatBotName}}</span> -->
					<div class="media-head round">
						<div
							class="avatar avatar-sm avatar-soft-primary avatar-icon avatar-rounded position-relative">
							<div class="avatar avatar-sm avatar-rounded">
								<div class="header-img">
									<!-- <img src="https://genaichatbotdev.blob.core.windows.net/chatbots/student/assets/images/Chatbot.svg?sp=r&st=2024-10-21T06:50:32Z&se=2026-09-01T14:50:32Z&sv=2022-11-02&sr=b&sig=nQEmE5Wx5mB4uLvN2F71wdpz1QgAWywRnOvz4HW%2FC74%3D" alt="user" class="avatar-img"> -->
									<img src="{{assetsPath.brandingAssetsStudent.StudentAzureBot}}" alt="user" class="avatar-img">
								</div>
								<!-- <img src="{{assetsPath.brandingAssetsStudent.Charlotte}}" alt="user" class="avatar-img"> -->
							</div>
							<!-- <span
								class="badge badge-success badge-indicator badge-indicator-lg badge-indicator-nobdr position-bottom-end-overflow-1" style="margin-bottom: 6px;"></span> -->
						</div>
						<div class="text-white"><span style="text-align: left;">{{chatBotName}}</span></div>
					</div>
					<!-- <span class="text-white" style="text-align: left; margin-right: 148px;">Charlotte</span> -->
					<div style="display: flex;">
						<a id="fade_out" href="javascript:void(0);" class="btn btn-sm btn-icon btn-dark btn-rounded" (click)="fadeInFadeOut()">
							<span class="icon"><span class="feather-icon">
								<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-eye-slash-fill" viewBox="0 0 16 16">
									<path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7 7 0 0 0 2.79-.588M5.21 3.088A7 7 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474z"/>
									<path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12z"/>
								  </svg>
							</span></span>
						</a>
						<a id="history_chat" class="btn btn-sm btn-icon btn-dark btn-rounded" title="FAQ & History">
							<span class="icon">
								<span class="feather-icon">
								<svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
									<rect id="image 116" x="0.951996" y="3.05176e-05" width="15.81" height="15.81" fill="url(#pattern0_2315_3397)"/>
									<defs>
										<pattern id="pattern0_2315_3397" patternContentUnits="objectBoundingBox" width="1" height="1">
											<use xlink:href="#image0_2315_3397" transform="matrix(0.00975958 0 0 0.0113636 0.0878199 0)"/>
										</pattern>
										<image id="image0_2315_3397" data-name="image.png" width="88" height="88" xlink:href="data:image/png;base64,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"/>
									</defs>
									</svg>
								</span>
							</span>
						</a>
						<a id="refresh_chat" class="btn btn-sm btn-icon btn-dark btn-rounded" title="Refresh chat">
							<span class="icon">
								<span class="feather-icon">
									<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M13.0837 10.8193C12.8869 12.0731 12.2757 13.2309 11.3412 14.1126C10.4064 14.9945 9.2003 15.5507 7.90852 15.6923C6.61668 15.8338 5.31444 15.5523 4.20357 14.893C3.09295 14.2339 2.23684 13.235 1.76431 12.0531C1.29188 10.8715 1.22809 9.57048 1.58233 8.35015C1.93663 7.12961 2.69031 6.05486 3.73033 5.29395C4.77061 4.53284 6.03866 4.12892 7.33845 4.14709C8.63823 4.16525 9.89393 4.60442 10.9116 5.39409" stroke="white" stroke-width="2" stroke-linecap="round"/>
										<path d="M13.3889 8.26372L7.38171 7.47662L12.1919 2.41539L13.3889 8.26372Z" fill="white"/>
									</svg>
								</span>
							</span>
						</a>
						<a id="maximize_chatbot" href="javascript:void(0);" class="btn btn-sm btn-icon btn-dark btn-rounded maximize-button" (click)="maximizeChat()" title="Maximize">
							<span class="icon">
								<span class="feather-icon" >
									<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
										<rect x="3.32129" y="1.41803" width="12.7476" height="12.748" fill="#015973" stroke="white"/>
										<rect class="path-fill" x="1.26001" y="3.48004" width="12.7476" height="12.748" fill="#014F68" stroke="white"/>
									</svg>
								</span>
							</span>
						</a>
						<a  id="minimize_chatbot" href="javascript:void(0);"
							class="btn btn-sm btn-icon btn-dark btn-rounded minimize-button" (click)="toggleVisibility()" title="Minimize">
							<span class="icon"><span class="feather-icon">
								<svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M4.11694 8.82324H12.0219" stroke="white" stroke-width="2" stroke-linecap="round"/>
									<rect x="0.664001" y="1.41797" width="14.81" height="14.81" rx="2.5" stroke="white"/>
								</svg>
							</span></span>
						</a>
					</div>
				</div>
				<!-- <div class="separator-full separator-light mt-0 opacity-10"></div> -->
				<div class="media-wrap">
					<div class="media">
						<!-- <div class="media-body">
							<div class="user-name">{{chatBotName}}</div>
							<div class="user-status">Active</div>
						</div> -->
					</div>
				</div>
			</header>
			<div class="chatbot-popup-body" style="margin-top:5.5rem;height:calc(100vh - 55%);">
				<div data-simplebar class="nicescroll-bar">
					<div>
						<div class="init-content-wrap">
							<div class="card card-shadow">
								<div class="card-body">
									<p class="card-text">Hello I can help with any question regarding enrollment or
										academic programs.<br><br>Select the topic or start chatting.</p>
									<button class="btn btn-block btn-primary text-nonecase start-conversation btn-conversation">Start a
										conversation</button>
								</div>
							</div>
							<div class="btn-wrap">
								<button id="starting_ques_1"
									class="btn btn-soft-primary text-nonecase btn-rounded start-conversation"><span><span
											class="btn-text">{{question1}}</span></span></button>
								<button id="starting_ques_2"
									class="btn btn-soft-primary text-nonecase btn-rounded start-conversation"><span><span
											class="btn-text">{{question2}}
										</span></span></button>
								<button id="starting_ques_3"
									class="btn btn-soft-primary text-nonecase btn-rounded start-conversation"><span><span
											class="btn-text">{{question3}}</span></span></button>
							</div>
						</div>
						<ul class="list-unstyled d-none">
							<li class="media received">
								<div class="avatar avatar-xs avatar-soft-primary avatar-icon avatar-rounded">
									<div class="avatar avatar-xs avatar-rounded">
										<img src="{{assetsPath.brandingAssetsStudent.StudentAzureBot}}" alt="user" class="avatar-img" style="height: 24px; width: 22px;">
										<!-- <img src="https://genaichatbotdev.blob.core.windows.net/chatbots/student/assets/images/Chatbot.svg?sp=r&st=2024-10-21T06:50:32Z&se=2026-09-01T14:50:32Z&sv=2022-11-02&sr=b&sig=nQEmE5Wx5mB4uLvN2F71wdpz1QgAWywRnOvz4HW%2FC74%3D" alt="user" class="avatar-img"> -->
									</div>
								</div>
								<div class="media-body">
									<div class="msg-box">
										<div>
											<p>Hello! How can I assist you today?</p>
										</div>
										<div class="history-card d-none" style="border-top: 4px solid green;border-radius: 8px;padding:0;">
											<div class="card" style="padding:1rem;">
												<h6>Chat History - </h6>
												<div class="card-body" style="padding:0.55rem 0; font-family: 'Halant';font-size: 22px;">
													</div>
													</div>
													</div>
									</div>

								</div>
							</li>

						</ul>
					</div>
				</div>
				<ng-container *ngIf="!isFaqConfigurationEnable">
				<div id="chat_FAQs" class="chat-history d-none" style="padding: 6px 5%;height: 23rem;overflow-y: scroll;">
					<div>
						<button id="faq_tab" class="btn tab-btn" style="width:fit-content;padding:0 2rem 0 0;font:Halant;font-weight:900;font-size: 20px;color:#C4C4C4;">FAQs<span class="bottom_border" style="display:none;width: 75%;left: 10%;border-bottom:2px solid #FDB71A;"></span></button>
						<button id="history_tab" class="btn tab-btn" style="width:fit-content;padding:0 2rem 0 0;font:Halant;font-weight:900;font-size: 20px;">History<span class="bottom_border" style="width:75%;left: 10%;border-bottom:2px solid #FDB71A;"></span></button>
					</div>
					<div id="faqTab" class="tab-content" style="display:none;">
						<div style="margin:1rem 0;display:flex;">	
							<div class="FAQs_category" style="font-weight: 900;color: black; font-family: 'Halant'; font-size: 15px;">Choose Category:</div>
							<select id="categorySelect" class="rounded-pill category-history">
								<option value="Tuition & Fees" style="cursor: pointer;">Tuition & Fees</option>
								<!-- <option value="Courses">Courses</option> -->
							</select>
							<button type="button" id="applyFaq" class="btn rounded-pill" style="background-color:#FDB71A;padding:3px 6%;font-weight: 700;" (click)="applyFAQsSelection()">Apply</button>
						</div>
						<div id="faqs-body" style="margin:2rem 2rem 0 0;">
							<div *ngIf="showChatFAQs && showChatFAQs.length">
								<li class="faqs_Queries" *ngFor="let chatFAQ of showChatFAQs;let i=index" id="{{i}}" style="position: relative;list-style: none;margin:6px 0;padding: 6.8px;font-family: 'Halant'; font-size: 16px;">
									<a id="{{i}}" class="faq-questions">{{chatFAQ}}</a>
								</li>
							</div>
						</div>
					</div>

					<div id="historyTab" class="tab-content" style="display:block; padding: 1rem;">
						<h6 id="chat-history-title">Loading... </h6>
						<div class="history-card" style="width:-webkit-fill-available;padding:0;">
							<div>
								<h6 id="chat-history-title"></h6>
								<div class="card-body" style="padding:0.55rem 0;">
									<div id="chat_history" style="margin-top: 0.6rem;">
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- <h3 style="border-bottom:2px solid rgb(255, 174, 0);width:fit-content;">FAQs</h3> -->
				</div>
				</ng-container>
				<ng-container *ngIf="isFaqConfigurationEnable">
				<div id="chat_FAQs" class="chat-history d-none"
					style="padding: 6px 5%;height: 55vh;overflow-y: scroll;">
					<div>
						<button *ngIf="isFaqConfigurationEnable" id="faq_tab" class="btn tab-btn"
							style="width:fit-content;padding:0 2rem 0 0;font:Halant;font-weight:900;font-size: 20px;color:#C4C4C4;" (click)="onclickFAQ(selectedDegreeCategory)">FAQs<span
								class="bottom_border"
								style="display:none;width: 75%;left: 10%;border-bottom:2px solid #FDB71A;"></span></button>
						<button *ngIf="!isFaqConfigurationEnable" id="faq_tab" class="btn tab-btn"
							style="width:fit-content;padding:0 2rem 0 0;font:Halant;font-weight:900;font-size: 20px;color:#C4C4C4;" (click)="onclickFAQ(selectedDegreeCategory)">FAQs<span
								class="bottom_border"
								style="display:none;width: 75%;left: 10%;border-bottom:2px solid #FDB71A;"></span></button>
						<button id="history_tab" class="btn tab-btn"
							style="width:fit-content;padding:0 2rem 0 0;font:Halant;font-weight:900;font-size: 20px;">History<span
								class="bottom_border"
								style="width:75%;left: 10%;border-bottom:2px solid #FDB71A;"></span></button>
					</div>
					<div id="faqTab" class="tab-content container" style="display:none;">
						<div style="display:flex; align-items:center;width: 100%;" class="row">
							<div class="FAQs_category"
								style="font-weight: 500;color: black; font-family: 'Mulish'; font-size: 16px; display: flex; margin-top: 5px;">
								<strong>Choose Degree Level:</strong></div>
							<select id="categorySelect" class="rounded-pill category-history col-md-4 mb-4"
								[(ngModel)]="selectedDegreeCategory"
								(change)="applyDegreeSelection($event)"
								style="flex-grow: 1; margin-right: 1rem; width: 200px; height: 35px; font-family: 'Mulish'; font-size: 16px; color: #006580;">
								<option *ngFor="let degree of degreeCategoryList" [value]="degree"
									style="cursor: pointer;" class="col-md-4 mb-4">{{degree}}</option>

							</select>
							<!-- <button type="button" id="applyFaq" class="btn rounded-pill col-md-2 mb-4"
								style="background-color:#FDB71A;padding:3px 6%;font-weight: 700; width: 100px; height: 35px;"
								(click)="applyDegreeSelection(selectedDegreeCategory)">Apply</button> -->
						</div>
						<div style="display:flex; align-items:center;width: 100%; margin-top: -10px;"
							*ngIf="isFaqConfigurationEnable && isDegreeCategorySelected" class="row">
							<div class="FAQs_category"
								style="font-weight: 500;color: black; font-family: 'Mulish'; font-size: 16px; display: flex; margin-top: 5px;">
								<strong>Choose Category:</strong></div>
							<select id="categorySelect" class="rounded-pill category-history col-md-4 mb-4"
								[(ngModel)]="selectedCategory" 
								(change)="applyFAQsSelection($event)"
								style="flex-grow: 1; margin-right: 1rem; width: 200px; height: 35px; font-family: 'Mulish'; font-size: 16px; color: #006580;">
								<option class="col-md-4 mb-4" *ngFor="let category of categoryList" [value]="category.category"
									style="cursor: pointer;">{{category.category}}</option>
								<!-- <option value="Courses">Courses</option> -->
							</select>
							<!-- <button type="button" id="applyFaq" class="btn rounded-pill col-md-2 mb-4"
								style="background-color:#FDB71A;padding:3px 6%;font-weight: 700; width: 100px; height: 35px;"
								(click)="applyFAQsSelection()">Apply</button> -->
						</div>
						<div style="display:flex; align-items:center;width: 100%; margin-top: -10px;" class="row" *ngIf="!isFaqConfigurationEnable">
							<div class="FAQs_category"
								style="font-weight: 500;color: black; font-family: 'Mulish'; font-size: 16px; display: flex; margin-top: 5px;">
								<strong>Choose Category:</strong></div>
							<select id="categorySelect" class="rounded-pill category-history col-md-4 mb-4" style="flex-grow: 1; margin-right: 1rem; width: 200px; height: 35px; font-family: 'Mulish'; font-size: 16px; color: #006580"
								[(ngModel)]="selectedCategory" (change)="applyFAQsSelection($event)">
								<!-- <option *ngFor="let category of categoryList"  [value]="category.category" style="cursor: pointer;">{{category.category}}</option> -->
								<option value="Courses" >General</option>
							</select>
							<!-- <button type="button" id="applyFaq" class="btn rounded-pill col-md-2 mb-4"
								style="background-color:#FDB71A;padding:3px 6%;font-weight: 700; width: 100px; height: 35px;"
								(click)="applyFAQsSelection()">Apply</button> -->
						</div>
						<div id="faqs-body" style="margin:1rem 2rem 0 0;">
							<div *ngIf="showChatFAQs && showChatFAQs.length">
								<div *ngFor="let chatFAQ of showChatFAQs;let i=index" id="{{i}}">
									<li class="faqs_Queries"
										style="position: relative;list-style: none;font-family: 'Mulish'; font-size: 16px;">
										<a id="{{i}}" class="faq-questions">{{chatFAQ}}</a>
									</li>
								</div>
							</div>
						</div>
					</div>
					<div id="historyTab" class="tab-content" style="display:block; padding: 1rem;">
						<h6 id="chat-history-title">Loading... </h6>
						<div class="history-card" style="width:-webkit-fill-available;padding:0;">
							<div>
								<h6 id="chat-history-title"></h6>
								<div class="card-body" style="padding:0.55rem 0;">
									<div id="chat_history" style="margin-top: 0.6rem;">
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- <h3 style="border-bottom:2px solid rgb(255, 174, 0);width:fit-content;">FAQs</h3> -->
				</div>
				</ng-container>
			</div>
			<footer>
				<div class="input-group d-none">
					<input type="text" id="input_msg_chat_popup" name="send-msg"
						class="input-msg-send form-control border-0 shadow-none" placeholder="Ask me anything...">
						<button id="send_query" class="btn icon">
							<svg width="31" height="28" viewBox="0 0 31 28" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path id="send_btn_icon" d="M29.3428 14.6689L1.38969 27.0379C1.38969 27.0379 0.918161 27.1317 0.729262 26.9428C0.540365 26.7539 0.584361 26.1833 0.584361 26.1833C0.585577 26.1564 0.586756 26.1408 0.586756 26.1408L3.73436 16.3812L18.1166 13.994L3.82226 11.2875L0.555872 1.80327C0.555872 1.80327 0.555553 1.33189 0.696492 1.09599C0.884794 0.813239 1.63955 0.908523 1.63955 0.908523L29.388 13.3009C29.388 13.3009 30.0964 13.7264 30.0968 14.0094C30.0971 14.2924 29.3428 14.6689 29.3428 14.6689Z" fill="#EBEBEB"/>
							</svg>
						</button>
				</div>
			</footer>
		</div>
		<a href="javascript:void(0);" class="btn-popup-open" (click)="toggleVisibility()">
			<div class="avatar avatar-sm avatar-icon avatar-rounded position-relative">
				<img src="{{assetsPath.brandingAssetsStudent.StudentAzureBot}}" alt="user" class="avatar-img">
				<!-- <img src="https://genaichatbotdev.blob.core.windows.net/chatbots/student/assets/images/Chatbot.svg?sp=r&st=2024-10-21T06:50:32Z&se=2026-09-01T14:50:32Z&sv=2022-11-02&sr=b&sig=nQEmE5Wx5mB4uLvN2F71wdpz1QgAWywRnOvz4HW%2FC74%3D" alt="user" class="avatar-img"> -->
			</div>
		</a>
		<!-- /Chat Popup -->
	</div>
